enum SitterCardVariantTypes {
  Base,
  Small,
}

export default SitterCardVariantTypes;
